import { render, staticRenderFns } from "./Models.vue?vue&type=template&id=3a31230b&scoped=true&"
import script from "./Models.vue?vue&type=script&lang=js&"
export * from "./Models.vue?vue&type=script&lang=js&"
import style0 from "./Models.vue?vue&type=style&index=0&id=3a31230b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a31230b",
  null
  
)

export default component.exports